var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73884 0.095293C7.47905 -0.0781806 7.12747 -0.0082859 6.954 0.251925L3.27947 5.75845L0.966211 3.44519C0.745158 3.22456 0.386842 3.22456 0.165789 3.44519C-0.0552632 3.66624 -0.0552632 4.02498 0.165789 4.24561L2.97042 7.05066C3.19147 7.27171 3.54979 7.27171 3.77084 7.05066C3.80789 7.01361 3.82937 6.96856 3.85421 6.92561C3.86095 6.91592 3.87147 6.91129 3.87779 6.90161L7.8959 0.880135C8.06895 0.620346 7.99905 0.268767 7.73884 0.095293",
    id: "Fill-1",
    fill: "#007f00",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.24dfc5e98d6f820d95e07d07f8011863.svg";
export { ForwardRef as ReactComponent };